import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import lgmMixin from '~/mixins/lgmMixin';
export default {

  data() {
    return {
      componentRendered: false,
      promotionBannerLoadedCount: 0,
      currentPageCategory: '',
      isEventTrackingReady: false,
    };
  },
  mixins: [eventTrackingMixins, lgmMixin],
  
  computed: {
  },
  created() {
    this.currentPageCategory = this.$route.params.productCat
  },
  mounted() {
    this.$nextTick(() => {
      this.setEventTrackingListenersForFiveStar()
    })
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeUpdate() {
  },
  updated() {
  },

  methods: {
    isProductDetailLink(el) {
      let href
      if (typeof el === 'string') {
        href = el
      } else if(typeof el === 'object') {
        href = el.getAttribute('href') || el.getAttribute('data-href') || null;
      }
      const patternProducts = /^.*\/products\/.*$/;
      if (href.match(patternProducts)) {
        return true;
      }
      return false;
    },
    getHrefFromClickableElement(el) {
      let href
      
      if (typeof el === 'string') {
        href = el
      }
      if (!href && el?.getAttribute) {
        href = el?.getAttribute('href') || null;
      }
      if (!href) {
        href = el?.target?.getAttribute('href');
      }
      if (!href) {
        href = el?.target?.parentElement?.getAttribute('href');
      }
      if (!href) {
        href = el?.target?.parentElement?.parentElement?.getAttribute('href');
      }
      return href
    },
    isInsurerPageLink(el) {
      const href = this.getHrefFromClickableElement(el);
      const patternInsurerPage = /^.*5star-products\/[\d]{4}\/insurer\/(.*)$/;
      
      // url pattern since 2025. 
      const patternInsurerPage2025 = /^.*5star-products-[\d]{4}\/insurer-(.*)$/;
      
      const matched = href?.match(patternInsurerPage) || href?.match(patternInsurerPage2025);
      if (matched) {
        return matched;
      }
      return false;
    },

    isLinkInProductSection(el) {
      const node = el.closest('.products');
      if (node) {
        return true;
      }
      return false;
    },
    isLinkInBannerButton(el) {
      const node = el.closest('.promotion-banner-responsive-section');
      if (node) {
        return true;
      }
      return false;
    },
    isLinkInImageBanner(el) {
      const node = el.closest('.full-width-banner-section');
      if (node) {
        return true;
      }
      return false;
    },
    isLinkInTextSection(el) {
      const node = el.closest('.text-section');
      if (node) {
        return true;
      }
      return false;
    },

    setEventTrackingListenersForFiveStar() {
      this.listenerTasks.push(
        this.eventTrackingListenersForFiveStar
        )

    },
    eventTrackingListenersForFiveStar() {
      const catPageItems = document.querySelectorAll('.five-star-products-container a, .five-star-products-container .cta-button')
      const insurerPageItems = document.querySelectorAll('.five-star-products-insurer-page a');

      const catPageAwardProductItems = Array.from(catPageItems).filter(function(link) {
        return link.closest('.five-star-products-award-product');
      });
      if (catPageAwardProductItems) {
        const item = catPageAwardProductItems
        const self = this
        item.forEach(function (el) {
          if (el.getAttribute('data-listener') === null) {
            el.setAttribute('data-listener', 'true')
            
            const dataFromClickableElement = self.extractDataFromClickedElement(el)
            const href = dataFromClickableElement?.href
  
            // #175 open_product_details
            if (self.isProductDetailLink(href)) {
              el.addEventListener('click', self.handleEventTracking_fiveStarProductCardOpenProdctDetails);
            }
            // #175 click_redirection
            if (self.isTransitionLink(href)) {
              el.addEventListener('click', self.handleEventTracking_fiveStarProductCardClickRedirection);
            }
            // #175 open_award_insurerpage_details
            if (self.isInsurerPageLink(href)) {
              el.addEventListener('click', self.handleEventTracking_fiveStarProductCardOpenAwardInsurerPageDetails);
            }
          }
          

        });
      }
      
      const catPageAwardInsurerItems = Array.from(catPageItems).filter(function(link) {
        return link.closest('.five-star-products-award-insurer-section');
      });
      if (catPageAwardInsurerItems) {
        const item = catPageAwardInsurerItems
        const self = this
        item.forEach(function (el) {
          if (el.getAttribute('data-listener') === null) {
            el.setAttribute('data-listener', 'true')
            
            // #176 Insurer page click
            if (self.isInsurerPageLink(el)) {
              el.addEventListener('click', self.handleEventTracking_fiveStarInsurerCardOpenAwardInsurerPageDetails);
            }

          }
        });
      }

      const insurerPageProductSectionItems = Array.from(insurerPageItems).filter(function(link) {
        return link.closest('.products-section');
      });
      if (insurerPageProductSectionItems) {
        const item = insurerPageProductSectionItems
        const self = this
        item.forEach(function (el) {
          
          if (el.getAttribute('data-listener') === null) {
            el.setAttribute('data-listener', 'true')
            
            const dataFromClickableElement = self.extractDataFromClickedElement(el)
            const href = dataFromClickableElement?.href
  
            // #177 5star_insurer_page_decoder_card_cta
            if (self.isProductDetailLink(el)) {
              el.addEventListener('click', self.handleEventTracking_fiveStarInsurerPageProductCardCtaOpenProdctDetails);
            }
  
            // // #LGM 5star_insurer_page_decoder_card_cta special handling
            if (self.isTransitionLink(href)) {
              el.addEventListener('click', self.handleEventTracking_fiveStarInsurerPageProductCardCtaOpenTransitionLink);
            }
          }

        });
      }

      // 178  click_redirection
      const insurerPageNonDocumentAndProductSectionItems = Array.from(insurerPageItems).filter(function(link) {
        return !link.closest('.document-section') && !link.closest('.products-section');
      });
      if (insurerPageNonDocumentAndProductSectionItems) {
        const item = insurerPageNonDocumentAndProductSectionItems
        const self = this
        item.forEach(function (el) {
          
          if (el.getAttribute('data-listener') === null) {
            el.setAttribute('data-listener', 'true')
            
            const dataFromClickableElement = self.extractDataFromClickedElement(el)
            const href = dataFromClickableElement?.href
            
            // #178 click_redirection
            if (self.isTransitionLink(href)) {
              el.addEventListener('click', self.handleEventTracking_fiveStarInsurerPageClickRedirectionLink);
            }
          }
        });
      }
      
      // 179 open_promo_details
      const insurerPagePromoDetailsItem = document.querySelectorAll('.five-star-products-insurer-page .remarks-button');
      if (insurerPagePromoDetailsItem) {
        const item = insurerPagePromoDetailsItem
        const self = this
        item.forEach(function (el) {
          if (el.getAttribute('data-listener') === null) {
            el.setAttribute('data-listener', 'true')
            
            el.addEventListener('click', self.handleEventTracking_fiveStarInsurerPagePromoDetails);
          }
        });
      }

      // 180 click_redirection_download
      const insurerPageDownloadItem = document.querySelectorAll('.five-star-products-insurer-page .document-section a');
      if (insurerPageDownloadItem) {
        const item = insurerPageDownloadItem
        const self = this
        item.forEach(function (el) {
          if (el.getAttribute('data-listener') === null) {
            el.setAttribute('data-listener', 'true')
            
            el.addEventListener('click', self.handleEventTracking_fiveStarInsurerPageDownloadButton);
          }
        });
      }
      
      this.isEventTrackingReady = true;
    },

    // #175 open_product_details
    // 5star_category_product_card
    handleEventTracking_fiveStarProductCardOpenProdctDetails(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const productCategoryElement = event.target.closest('.event-product-category-element')
      const productCategory = productCategoryElement?.getAttribute('data-event-product-category')
      const cardTitle = dataFromClickedElement?.card_title
      const eventTrackingParams = this.initEventTrackingParams()
      const insurerName = dataFromClickedElement?.insurer_name
      
      eventTrackingParams.a = 'open_product_details'
      eventTrackingParams.l = undefined 
      eventTrackingParams.c = `5star_category_product_card`
      eventTrackingParams.cd.product_category = productCategory
      eventTrackingParams.cd.product_name = cardTitle
      eventTrackingParams.cd.insurer_name = insurerName
    
      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
    },
    // #175 click_redirection
    // 5star_category_product_card
    handleEventTracking_fiveStarProductCardClickRedirection(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const productCategoryElement = event.target.closest('.event-product-category-element')
      const productCategory = productCategoryElement?.getAttribute('data-event-product-category')
      const cardTitle = dataFromClickedElement?.card_title
      const eventTrackingParams = this.initEventTrackingParams()
      const insurerName = dataFromClickedElement?.insurer_name
      
      eventTrackingParams.a = 'click_redirection'
      eventTrackingParams.l = undefined
      eventTrackingParams.c = `5star_category_product_card`
      eventTrackingParams.cd.product_category = productCategory
      eventTrackingParams.cd.product_name = cardTitle
      eventTrackingParams.cd.insurer_name = `${insurerName}`
    
      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
    },
    // #175 open_award_insurerpage_details
    // 5star_category_product_card
    handleEventTracking_fiveStarProductCardOpenAwardInsurerPageDetails(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const productCategoryElement = event.target.closest('.event-product-category-element')
      const productCategory = productCategoryElement?.getAttribute('data-event-product-category')
      const cardTitle = dataFromClickedElement?.card_title
      const eventTrackingParams = this.initEventTrackingParams()
      const insurerName = dataFromClickedElement?.insurer_name
      
      eventTrackingParams.a = 'open_award_insurerpage_details'
      eventTrackingParams.l = undefined
      eventTrackingParams.c = `5star_category_product_card`
      eventTrackingParams.cd.product_category = productCategory
      eventTrackingParams.cd.product_name = cardTitle
      eventTrackingParams.cd.insurer_name = `${insurerName}`
    
      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
    },

    // #176 open_award_insurerpage_details
    // 5star_category_page_{insurer}
    handleEventTracking_fiveStarInsurerCardOpenAwardInsurerPageDetails(event) {
      console.debug('#176 handleEventTracking_fiveStarInsurerCardOpenAwardInsurerPageDetails')
      const eventTrackingParams = this.initEventTrackingParams()
      const insurerSlug = this.isInsurerPageLink(event)[1]
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      
      eventTrackingParams.a = 'open_award_insurerpage_details'
      eventTrackingParams.l = href
      eventTrackingParams.c = `5star_category_page_${insurerSlug}`
      eventTrackingParams.cd.product_category = undefined
      eventTrackingParams.cd.product_name = undefined
      eventTrackingParams.cd.insurer_name = `${insurerSlug}`
      
      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
      
      this.isEventTrackingReady = true;
    },
    // #177 open_product_details
    // 5star_insurer_page_decoder_card_cta
    handleEventTracking_fiveStarInsurerPageProductCardCtaOpenProdctDetails(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      const productCategoryElement = event.target.closest('.event-product-category-element')
      const productCategory = productCategoryElement?.getAttribute('data-event-product-category')
      const cardTitle = dataFromClickedElement?.card_title
      const eventTrackingParams = this.initEventTrackingParams()
      const insurerName = dataFromClickedElement?.insurer_name
      
      eventTrackingParams.a = 'open_product_details'
      eventTrackingParams.l = href 
      eventTrackingParams.c = `5star_insurer_page_decoder_card_cta`
      eventTrackingParams.cd.product_category = productCategory
      eventTrackingParams.cd.product_name = cardTitle
      eventTrackingParams.cd.insurer_name = insurerName
    
      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
    },

    // #LGM 5star_insurer_page_decoder_card_cta special handling
    handleEventTracking_fiveStarInsurerPageProductCardCtaOpenTransitionLink(event) {
      event.preventDefault();

      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      const cardTitle = dataFromClickedElement?.card_title
      const eventTrackingParams = this.initEventTrackingParams()
      
      const data = this.extractDataFromTransitionLink(href)
      eventTrackingParams.a = 'click_redirection'
      eventTrackingParams.l = href
      eventTrackingParams.c = `5star_insurer_award_${data.category}_${data.insurer}_hyperlink_${data.link}`
      eventTrackingParams.cd.product_category = `${data.category}`
      eventTrackingParams.cd.product_name = cardTitle
      eventTrackingParams.cd.insurer_name = `${data.insurer}`
      
      this.openWindowWithLGMUrl(event, 'a.product-card-cta-link', eventTrackingParams, 'transitionLink');

      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
    },
    
    // #178 click_redirection
    // 5star_insurer_award_{category}_{insurer name}_hyperlink_{hyperlink}
    handleEventTracking_fiveStarInsurerPageClickRedirectionLink(event) {
      event.preventDefault();

      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      const cardTitle = dataFromClickedElement?.card_title
      const eventTrackingParams = this.initEventTrackingParams()
      
      const data = this.extractDataFromTransitionLink(href)
      eventTrackingParams.a = 'click_redirection'
      eventTrackingParams.l = href
      eventTrackingParams.c = `5star_insurer_award_${data.category}_${data.insurer}_hyperlink_${data.link}`
      eventTrackingParams.cd.product_category = `${data.category}`
      eventTrackingParams.cd.product_name = cardTitle
      eventTrackingParams.cd.insurer_name = data.insurer
    
      if (event.target?.closest('.btn1 a')) {
        // cross-selling-banner
        this.openWindowWithLGMUrl(event, '.btn1 a', eventTrackingParams, 'transitionLink');
      } else {
        this.openWindowWithLGMUrl(event, 'a', eventTrackingParams, 'transitionLink');
      }

      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
    },

    // #179 open_promo_details
    // 5star_insurer_page_{insurer}
    handleEventTracking_fiveStarInsurerPagePromoDetails(event) {

      const eventTrackingParams = this.initEventTrackingParams()
      const insurerCodeElement = event.target.closest('.event-insurer-code-element')
      const insurerCode = insurerCodeElement?.getAttribute('data-event-insurer-code')
      
      eventTrackingParams.a = 'open_promo_details'
      eventTrackingParams.l = undefined
      eventTrackingParams.c = `5star_insurer_page_${insurerCode}`
      eventTrackingParams.cd.product_category = undefined
      eventTrackingParams.cd.product_name = undefined
      eventTrackingParams.cd.insurer_name = insurerCode
      
      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
    },

    // #180 click_redirection_download
    // 5star_insurer_award_{category}_{insurer name}_hyperlink_{hyperlink}
    handleEventTracking_fiveStarInsurerPageDownloadButton(event) {

      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      const eventTrackingParams = this.initEventTrackingParams()
      const data = this.extractDataFromTransitionLink(href)
      
      eventTrackingParams.a = 'click_redirection_download'
      eventTrackingParams.l = href
      eventTrackingParams.c = `5star_insurer_award_${data.category}_${data.insurer}_hyperlink_${data.link}`
      eventTrackingParams.cd.product_category = undefined
      eventTrackingParams.cd.product_name = undefined
      eventTrackingParams.cd.insurer_name = `${data.insurer}`
      
      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
    },

  },
  
  watch: {
  }
};